/**
 * ✅ 할 일(Task) — backend /tasks 와 1:1 (v2.319.0 · Salesforce 기능·메뉴 검토 F4)
 */
import { api } from './api';

export const TASK_STATUSES = ['미시작', '진행', '완료', '보류'] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];
export const TASK_PRIORITIES = ['높음', '보통', '낮음'] as const;
export type TaskPriority = (typeof TASK_PRIORITIES)[number];
export type TaskRelatedKind = 'sales' | 'partner' | 'maintenance' | 'deal';

export interface Task {
  id: number;
  title: string;
  dueDate: string | null;
  status: TaskStatus;
  priority: TaskPriority;
  assigneeUserId: string;
  assigneeName: string | null;
  relatedKind: TaskRelatedKind | null;
  relatedId: string | null;
  relatedLabel: string | null;
  note: string | null;
  createdBy: string;
  createdByName: string | null;
  createdAt: string;
  updatedAt: string;
  doneAt: string | null;
  /** 기한이 오늘보다 앞이고 안 끝남 */
  overdue: boolean;
}

export interface TaskListParams {
  scope?: 'mine' | 'all';
  status?: 'open' | 'done' | 'all';
  relatedKind?: TaskRelatedKind;
  relatedId?: string;
  q?: string;
}

export async function listTasks(p: TaskListParams = {}): Promise<Task[]> {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) if (v) sp.set(k, String(v));
  const r = await api.get<{ rows: Task[] }>(`/tasks${sp.toString() ? `?${sp}` : ''}`);
  return r.rows;
}

export interface TodayTasks {
  today: string;
  overdue: Task[];
  todayRows: Task[];
  upcoming: Task[];
  noDate: Task[];
  counts: { overdue: number; today: number; upcoming: number; noDate: number };
}
export async function todayTasks(): Promise<TodayTasks> {
  return api.get<TodayTasks>('/tasks/today');
}

export interface TaskCreateInput {
  title: string;
  dueDate?: string | null;
  priority?: TaskPriority;
  assigneeUserId?: string;
  relatedKind?: TaskRelatedKind | null;
  relatedId?: string | null;
  note?: string | null;
}
export async function createTask(input: TaskCreateInput): Promise<Task> {
  return api.post<Task>('/tasks', input);
}

export type TaskPatchInput = Partial<Pick<Task, 'title' | 'dueDate' | 'status' | 'priority' | 'assigneeUserId' | 'note'>>;
export async function patchTask(id: number, patch: TaskPatchInput): Promise<Task> {
  return api.patch<Task>(`/tasks/${id}`, patch);
}
export async function deleteTask(id: number): Promise<void> {
  await api.delete<{ deleted: boolean }>(`/tasks/${id}`);
}

/** 연결 대상 → 여는 주소(영업건·딜은 바로 열림 · 거래처는 360 · 유지보수는 화면) */
export function taskRelatedPath(t: Pick<Task, 'relatedKind' | 'relatedId'>): string | null {
  if (!t.relatedKind || !t.relatedId) return null;
  switch (t.relatedKind) {
    case 'sales': return `/sales?open=${encodeURIComponent(t.relatedId)}`;
    case 'partner': return `/partners?open=${encodeURIComponent(t.relatedId)}`;
    case 'deal': return `/deal-registration?deal=${encodeURIComponent(t.relatedId)}`;
    case 'maintenance': return '/maintenance';
    default: return null;
  }
}

/** 「11/05(수)」 */
export function dueLabel(d: string | null): string {
  if (!d) return '';
  const dt = new Date(d + 'T00:00:00');
  const dow = ['일', '월', '화', '수', '목', '금', '토'][dt.getDay()] ?? '';
  return `${d.slice(5).replace('-', '/')}(${dow})`;
}
